<template>
    <div id="order_data" class="order-data">
        <PopupWindow
            v-if="isVisiblePopup"
            :key="modal"
            :popupName="modal.popupName"
            :header="modal.header"
            :info="modal.info"
            :buttonText="modal.button"
            :callback="modal.callback"
            :buttonText2="modal.button2"
            :color="modal.color"
        ></PopupWindow>

        <div class="order-data__list">
            <div
                v-for="order in orders"
                :id="'current_order_' + order.order_number"
                :key="'current_order_' + order.order_number"
                class="order-data__list-item"
            >
                <!-- order-data-item -->
                <div class="order-data-item">
                    <div class="order-data-item__title">Заказ №{{ order.order_number }}</div>

                    <div class="order-data-item__card">
                        <div class="container-fluid">
                            <div class="row order-data-item__heading">
                                <div class="col">
                                    <div class="order-data-item__heading-summary">
                                        <div class="order-data-item__heading-summary-datetime">
                                            <img
                                                src="../../../assets/IMGS/SVG/calendar_grey.svg"
                                                alt="calendar"
                                                style="width: 18px; height: 18px"
                                            />
                                            <div class="order-data-item__heading-summary-datetime-text">
                                                {{ order.order_data_n_time }}
                                            </div>
                                        </div>

                                        <div class="order-data-item__heading-summary-state">
                                            <template v-if="order.is_invalid">
                                                <img
                                                    src="../../../assets/IMGS/SVG/invalidPeople.svg"
                                                    alt="invalidPeople"
                                                    style="
                                                        filter: invert(20%) sepia(33%) saturate(7380%)
                                                            hue-rotate(120deg) brightness(94%) contrast(89%);
                                                    "
                                                />
                                            </template>
                                            <template v-if="order.is_pregnant">
                                                <img
                                                    src="../../../assets/IMGS/SVG/pregnantPeople.svg"
                                                    alt="pregnantPeople"
                                                    style="
                                                        filter: invert(20%) sepia(33%) saturate(7380%)
                                                            hue-rotate(120deg) brightness(94%) contrast(89%);
                                                    "
                                                />
                                            </template>
                                            <template v-if="order.is_child">
                                                <img
                                                    src="../../../assets/IMGS/SVG/child.svg"
                                                    alt="child"
                                                    style="
                                                        filter: invert(20%) sepia(33%) saturate(7380%)
                                                            hue-rotate(120deg) brightness(94%) contrast(89%);
                                                    "
                                                />
                                            </template>
                                        </div>

                                        <div class="order-data-item__heading-summary-patient">
                                            {{ order.order_patient_info }}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="col-12 col-lg-auto order-data-item__heading-status d-flex align-items-center justify-content-center"
                                    :class="{
                                        'order-data-item__heading-status--cancelled':
                                            order['order_status'] == 'Отменен',
                                        'order-data-item__heading-status--current': true,
                                    }"
                                >
                                    <div>{{ order['order_status'] }}</div>
                                    <img src="../../../assets/IMGS/SVG/info_grey.svg" alt="info" />
                                </div>
                            </div>
                            <!-- ./ SUMMARY -->

                            <!-- DESCRIPTION -->
                            <div class="order-data-item__description row gy-3 py-3">
                                <div>
                                    <table>
                                        <tr>
                                            <td>
                                                <div><img src="../../../assets/IMGS/SVG/clock.svg" alt="clock" /></div>
                                            </td>
                                            <td>
                                                <div class="departure">{{ order.order_time_in }}</div>
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center" style="padding-top: 2px">
                                                    <img src="../../../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="destination">{{ order.order_address_in }}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <div class="d-flex align-items-center" style="padding-top: 2px">
                                                    <img src="../../../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="destination">{{ order.order_address_out }}</div>
                                            </td>
                                        </tr>
                                        <tr v-if="order.order_is_return && order.if_wait">
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <div class="d-flex align-items-center" style="padding-top: 2px">
                                                    <img src="../../../assets/IMGS/SVG/arrow_green_l.svg" alt="arrow" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="destination">{{ order.order_address_in }}</div>
                                            </td>
                                        </tr>
                                        <tr v-else-if="order.order_is_return">
                                            <td>
                                                <div><img src="../../../assets/IMGS/SVG/clock.svg" alt="clock" /></div>
                                            </td>
                                            <td>
                                                <div class="departure">{{ order.order_time_out }}</div>
                                            </td>
                                            <td>
                                                <div class="d-flex align-items-center" style="padding-top: 2px">
                                                    <img src="../../../assets/IMGS/SVG/arrow_green_l.svg" alt="arrow" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="destination">{{ order.order_address_in }}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div class="">
                                    <button
                                        id="cancel"
                                        value="Отменить"
                                        class="ui-button ui-button--md ui-button--red"
                                        v-on:click="cancelOrder()"
                                    >
                                        Отменить
                                    </button>
                                </div>
                            </div>
                            <!-- ./ DESCRIPTION -->

                            <div style="height: 0; border-bottom: 1px solid #747474; opacity: 0.3"></div>

                            <!-- CARRIERS -->
                            <div class="row gy-3 py-3 order-data-item__offers">
                                <div class="order-data-item__offers-title">
                                    <!-- <template v-if="orders[0]['order_specific_carrier']">
                                        Выбор или отклонение предложения перевозчика
                                    </template> -->

                                    <template v-if="carriers.length > 0">
                                        Перевозчики, откликнувшиеся на Вашу заявку. Можете выбрать любого
                                    </template>

                                    <template v-else>
                                        Пожалуйста, дождитесь предложений от перевозчиков. Они формируются…
                                    </template>
                                </div>

                                <div v-if="carriers.length > 0">
                                    <div class="order-data-item__offers-list d-flex flex-column">
                                        <div
                                            v-for="carrier in carriers"
                                            :key="carrier['id_owner']"
                                            class="carrier-item row gy-2"
                                        >
                                            <div class="col-md">
                                                <div class="carrier-item__info px-4 py-2">
                                                    <div class="d-inline-flex">
                                                        {{ carrier['org_name'] }}
                                                        <div class="ms-2">
                                                            <HoverIcon>
                                                                <template v-slot:hoverText>
                                                                    {{ carrier['org_name'] }},
                                                                    {{ carriers['region'] }}
                                                                </template>
                                                            </HoverIcon>
                                                        </div>
                                                    </div>
                                                    <div class="">
                                                        <strong>{{ carrier['price'] }}
                                                        {{ carrier['price'] ? '₽' : '' }}</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-auto ms-auto">
                                                <button
                                                    :id="'choose_' + carrier['id_owner']"
                                                    v-on:click="chooseCarrier(carrier['id_owner'])"
                                                    class="ui-button ui-button--md ui-button--secondary"
                                                    :class="{
                                                        'ui-button--disabled': carrier['status'] != '1',
                                                    }"
                                                    :disabled="carrier['status'] != '1'"
                                                >
                                                    Выбрать
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ./order-data-item -->
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { useCookies } from 'vue3-cookies';
import popup from '../../ModalComponent.vue';
import HoverIcon from '../../HoverInfoComponent.vue';

var current_orders = [{}];
var current_carriers = {
    carrier_name: [],
    carrier_stars: [],
    carrier_when_ready: [],
    carrier_price: [],
    carrier_order_status: 'Создан',
};

const url_params = window.location.href.split('/');
const user_uuid = url_params[url_params.length - 2];
const order_id = url_params[url_params.length - 1];

export default {
    name: 'OrderData',
    el: '#order_data',
    components: {
        PopupWindow: popup,
        HoverIcon,
    },
    data() {
        return {
            statusOrderName: 'Выбор исполнителя',
            modal: {
                popupName: 'default',
                header: 'Подтверждение',
                info: '',
                color: '#0ECCAA',
                button: '',
                button2: '',
                callback: function () {},
            },
            isVisiblePopup: false,
            orders: current_orders,
            carriers: current_carriers,
            showPage: true,
        };
    },
    setup() {
        const { cookies } = useCookies();
        return { cookies };
    },
    mounted() {
        if (localStorage.justCreatedOrder == 'true') {
            localStorage.justCreatedOrder = '';
            (this.modal = {
                header: 'Информация',
                info: 'Заказ был успешно создан!',
                button: 'ОК',
                color: '#0ECCAA',
            }),
                (this.isVisiblePopup = true);
        }

        this.renderCurrentOrder();
        setInterval(() => {
            this.renderCarriers();
        }, 5000);
    },
    methods: {
        getCookie(val) {
            return this.cookies.get(val);
        },
        setTitle() {
            let metaTitle = document.querySelector('title');
            if (metaTitle) {
                var title = metaTitle.innerHTML;
                title = `${title}`.replace(':id', this.orders[0].order_number);
                metaTitle.innerHTML = title;
            }
            let metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                var desc = metaDescription.content;
                desc = `${desc}`.replace(':id', this.orders[0].order_number);
                metaDescription.setAttribute('content', desc);
            }
        },
        cancelOrder() {
            var vm = this;
            vm.modal = {
                popupName: 'cancelOrder',
                header: 'Подтверждение',
                info: 'Укажите, пожалуйста причину отмены заказа',
                button: 'Отменить',
                button2: 'Вернуться',
                color: '#0ECCAA',
                callback: function (element, comment) {
                    if (element != 'Вернуться') {
                        $.ajax({
                            type: 'GET',
                            url:
                                global.BACKEND_URL +
                                `/my_orders/api_button/cancel_order?order_id=${order_id}&user_uuid=${user_uuid}&comment=${comment}`,
                            success: function () {
                                window.location.href = '/my_orders';
                            },
                            error: function () {
                                console.log('Not success :(');
                            },
                            dataType: 'text',
                            contentType: 'application/json',
                        });
                    }
                },
            };
            vm.isVisiblePopup = true;
        },
        chooseCarrier(owner_id) {
            var vm = this;
            $.ajax({
                type: 'GET',
                url:
                    global.BACKEND_URL +
                    `/my_orders/api_button/confirm_order?order_id=${order_id}&owner_id=${owner_id}&user_uuid=${user_uuid}`,
                success: function () {
                    if (!vm.getCookie('mtu_refresh_token')) {
                        var customer_name = vm.customer_name;
                        var customer_patronymic = vm.customer_patronymic;
                        var customer_phone = vm.customer_phone;
                        var customer_email = vm.customer_email;
                        var customer_is_registered = vm.customer_is_registered;
                        if (customer_is_registered == 'false') {
                            vm.modal = {
                                header: 'Информация',
                                info: 'Ваш заказ принят исполнителем. Перевозчик свяжется с Вами. Для отслеживания статуса заказа Вам необходимо зарегистрироваться в сервисе.',
                                button: 'Дальше',
                                color: '#0ECCAA',
                                callback: function () {
                                    window.location.href =
                                        `/authorization?redirect=registration&name=${customer_name}&patronymic=${customer_patronymic}` +
                                        `&phone=${customer_phone}&email=${customer_email}`;
                                },
                            };
                            vm.isVisiblePopup = true;
                        } else {
                            vm.modal = {
                                header: 'Информация',
                                info: 'Ваш заказ принят исполнителем. Перевозчик свяжется с Вами. Для отслеживания статуса заказа Вам необходимо авторизоваться в сервисе.',
                                button: 'Дальше',
                                color: '#0ECCAA',
                                callback: function () {
                                    window.location.href = `/authorization?redirect=authorization&email=${customer_email}`;
                                },
                            };
                            vm.isVisiblePopup = true;
                        }
                    } else {
                        window.location.href = '/my_orders';
                    }
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'text',
                contentType: 'application/json',
            });
        },
        renderCurrentOrder() {
            var vm = this;
            $.ajax({
                type: 'GET',
                url: global.BACKEND_URL + `/order_data/${user_uuid}/${order_id}`,
                success: function (data) {
                    current_orders = [
                        {
                            index: 1,
                            order_number: data['order_id'],
                            order_data_n_time: data['order_date'],
                            order_patient_info: data['patient_info'].substring(
                                0,
                                data['patient_info'].indexOf(',', data['patient_info'].indexOf(',') + 1)
                            ),
                            order_status: data['status'],
                            order_time_in: data['time_start'],
                            order_address_in: data['address_1'],
                            order_time_out: data['time_end'],
                            order_address_out: data['address_2'],
                            order_specific_carrier: data['is_particular_owner'] == 'true',
                            order_is_return: data['is_return'] == 'true',
                            if_wait: data['is_wait'] == 'true',
                            is_invalid: data['isInvalid'] == 'true',
                            is_pregnant: data['isPregnant'] == 'true',
                            is_child: data['isChild'] == 'true',
                        },
                    ];
                    vm.orders = current_orders;
                    vm.customer_name = data['customer_name'];
                    vm.customer_patronymic = data['customer_patronymic'];
                    vm.customer_phone = data['customer_phone'];
                    vm.customer_email = data['customer_email'];
                    vm.customer_is_registered = data['isRegisteredUser'];
                    var mtu_refresh_token = vm.getCookie('mtu_refresh_token');
                    if (data['status'] != 'Создан') {
                        if (mtu_refresh_token === '') {
                            window.location.href = '/authorization';
                        } else {
                            window.location.href = '/my_orders';
                        }
                    }
                    vm.setTitle();
                    vm.renderCarriers();
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'json',
                contentType: 'application/json',
            });
        },
        renderCarriers() {
            var vm = this;
            $.ajax({
                type: 'GET',
                url: global.BACKEND_URL + `/order_data/get_responses?order_id=${order_id}&user_uuid=${user_uuid}`,
                success: function (data) {
                    vm.carriers = data;
                    // current_carriers = {
                    //     carrier_name: [],
                    //     carrier_stars: [],
                    //     carrier_id: [],
                    //     carrier_when_ready: [],
                    //     carrier_price: [],
                    //     status: [],
                    //     region: [],
                    // };
                    // current_carriers['carrier_order_status'] = vm.orders[0]['order_status'];
                    // for (var single_data of data) {
                    //     current_carriers['carrier_name'] = [
                    //         ...current_carriers['carrier_name'],
                    //         single_data['org_name'],
                    //     ];
                    //     current_carriers['carrier_stars'] = [...current_carriers['carrier_stars'], single_data['rate']];
                    //     current_carriers['carrier_id'] = [...current_carriers['carrier_id'], single_data['id_owner']];
                    //     current_carriers['status'] = [...current_carriers['status'], single_data['status']];
                    //     if (single_data['region'] == null) {
                    //         current_carriers['region'] = [...current_carriers['region'], 'регион не выбран'];
                    //     } else {
                    //         current_carriers['region'] = [...current_carriers['region'], single_data['region']];
                    //     }
                    //     if (single_data['status'] != '1') {
                    //         if (single_data['status'] == '0') {
                    //             current_carriers['carrier_when_ready'] = [
                    //                 ...current_carriers['carrier_when_ready'],
                    //                 'Перевозчик еще не подтвердил заказ',
                    //             ];
                    //             current_carriers['carrier_order_status'] = 'Создан';
                    //             $('.order_status_current').removeClass('order_cancel_status');
                    //         } else {
                    //             current_carriers['carrier_when_ready'] = [
                    //                 ...current_carriers['carrier_when_ready'],
                    //                 'Перевозчик отменил заказ',
                    //             ];
                    //             current_carriers['carrier_order_status'] = 'Отменен';
                    //             vm.orders[0]['order_status'] = 'Отменен';
                    //             $('.order_status_current').addClass('order_cancel_status');
                    //         }
                    //         current_carriers['carrier_price'] = [...current_carriers['carrier_price'], ''];
                    //     } else {
                    //         current_carriers['carrier_when_ready'] = [
                    //             ...current_carriers['carrier_when_ready'],
                    //             single_data['comment'],
                    //         ];
                    //         current_carriers['carrier_price'] = [
                    //             ...current_carriers['carrier_price'],
                    //             single_data['price'],
                    //         ];
                    //         current_carriers['carrier_order_status'] = 'Создан';
                    //     }
                    // }
                    // vm.carriers = current_carriers;
                },
                error: function () {
                    console.log('Not success :(');
                },
                dataType: 'json',
                contentType: 'application/json',
            });
        },
    },
};
</script>

<!-- <style lang="css" scoped src="@/assets/css/order_data.css"></style> -->

<style lang="scss">
.order-data {
    // color: #747474;

    &__list {
        &-item {
            margin-bottom: 32px;
        }
    }

    .order-data-item {
        color: #747474;

        &__title {
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 24px;
        }

        &__card {
            font-size: 16px;
            border: 1px solid rgba(116, 116, 116, 0.1);
            border-left: 8px solid #0eccaa;
        }

        &__heading {
            background-color: #b8f4ea;

            &-summary {
                display: flex;
                flex-wrap: wrap;
                gap: 8px 22px;
                padding: 16px 0;

                color: #6e7675;

                &-datetime {
                    display: inline-flex;
                    align-items: center;
                    gap: 12px;

                    &-text {
                        font-size: 18px;
                        font-weight: 700;
                        white-space: no-wrap;
                    }
                }

                &-state {
                    display: inline-flex;
                    align-items: center;
                    gap: 14px;
                }

                &-patient {
                    font-size: 16px;
                }
            }

            &-status {
                min-width: 238px;
                height: 54px;

                gap: 12px;
                color: #fff;
                font-size: 18px;
                font-weight: 500;
                text-transform: uppercase;

                &--current {
                    background-color: #0eccaa;
                }

                &--cancelled {
                    background-color: #ee6870 !important;
                }
            }
        }

        &__description {
            table {
                tr {
                    td {
                        padding: 12px 0;

                        &:nth-child(1) {
                            width: 18px;
                        }

                        &:nth-child(3) {
                            width: 22px;
                        }

                        .departure {
                            padding: 0 8px;
                            font-weight: 700;
                        }

                        .destination {
                            padding-left: 8px;
                        }

                        @media screen and (min-width: 768px) {
                            .departure {
                                padding: 0 40px 0 18px;
                            }

                            .destination {
                                padding-left: 28px;
                            }
                        }
                    }
                }
            }
        }

        &__offers {
            &-title {
                font-size: 20px;
                font-weight: 700;
            }

            &-list {
                gap: 24px;

                .carrier-item {
                    &__info {
                        display: flex;
                        gap: 8px 18px;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        background-color: rgba(75, 172, 227, 0.1);
                        border-radius: 8px;
                        height: 100%;
                        font-size: 20px;
                        font-weight: 700;
                    }
                }
            }
        }
    }
}
</style>
